// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { Generation } from './Generation';
import { BEComponent } from './BEComponent';
import { BEInterface } from './BEInterface';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { InterfaceGenerationExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/InterfaceGenerationExtend';
/**
 * 接口继承关系 实体类
 * 接口继承关系
 */
export class InterfaceGeneration extends Generation {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 父接口 的ID */
  private _superInterface_ID: string;

  /** 获取：父接口 的ID */
  public get superInterface_ID() {
    return this._superInterface_ID;
  }

  /** 设置：父接口 的ID */
  public set superInterface_ID(value: string) {
    this._superInterface_ID = value;
  }

  /** 父接口  */
  private _superInterface: BEInterface;

  /** 获取：父接口  */
  public get superInterface() {
    return this._superInterface;
  }

  /** 设置：父接口  */
  public set superInterface(value: BEInterface) {
    this._superInterface = value;
    if (value !== null) {
      this.superInterface_ID = value.id;
    } else {
      this.superInterface_ID = '';
    }
  }

  /** 子接口 的ID */
  private _subInterface_ID: string;

  /** 获取：子接口 的ID */
  public get subInterface_ID() {
    return this._subInterface_ID;
  }

  /** 设置：子接口 的ID */
  public set subInterface_ID(value: string) {
    this._subInterface_ID = value;
  }

  /** 子接口  */
  private _subInterface: BEInterface;

  /** 获取：子接口  */
  public get subInterface() {
    return this._subInterface;
  }

  /** 设置：子接口  */
  public set subInterface(value: BEInterface) {
    this._subInterface = value;
    if (value !== null) {
      this.subInterface_ID = value.id;
    } else {
      this.subInterface_ID = '';
    }
  }

  constructor() {
    super();
    InterfaceGenerationExtend.Init(this);
    this._component_ID = '';
    this._component = null;
    this._superInterface_ID = '';
    this._superInterface = null;
    this._subInterface_ID = '';
    this._subInterface = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: InterfaceGeneration, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.superInterface_ID = element.superInterface_ID;
      if (hasReference && element.superInterface !== null) {
        this.superInterface = element.superInterface;
      }
      this.subInterface_ID = element.subInterface_ID;
      if (hasReference && element.subInterface !== null) {
        this.subInterface = element.subInterface;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    this.superInterface_ID = json.SuperInterface_ID;
    // if (json.SuperInterface !== null) {
    //   this.superInterface = BEInterface.Create(json.SuperInterface);
    // }
    this.subInterface_ID = json.SubInterface_ID;
    // if (json.SubInterface !== null) {
    //   this.subInterface = BEInterface.Create(json.SubInterface);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    json.SuperInterface_ID = this.superInterface_ID;
    json.SubInterface_ID = this.subInterface_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): InterfaceGeneration {
    const interfaceGeneration = new InterfaceGeneration();
    interfaceGeneration.Deserialize(json);
    interfaceGeneration.json = json;
    return interfaceGeneration;
  }
}
